import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import T from 'i18n-react';
import cx from 'classnames';
import { actions as formActions } from 'react-redux-form';
import lodashGet from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import {
  Button,
  SelectDropdown,
  DatePicker,
  MentionInput,
  TextFieldCore,
  StatusColorIndicatorOption,
  Label,
  SvgIcon,
  Checkbox,
} from '@adsk/bim360-matrix-react-components';
import { connect } from '../../../../../redux/connect';
import { updateIssueAction, createCommentAction } from '../../../../../redux/actions';
import {
  getTransitionFormState,
  getTransitionFormAttributes,
  getCurrentIssuePreviewStatusOptions,
  getActiveUsers,
  getGroupedProjectActiveEntities,
  getGroupedProjectActiveEntitiesForMentionComponent,
  getOxygenMappings,
  getDocumentCollection,
  getCurrentUser,
  getCurrentViewType,
  rfiCustomIdentifierAnalyticsData,
} from '../../../../../redux/selectors';
import {
  issueAttributesType,
  statusOptionsArrayType,
  documentType,
  userType,
  oxygenType,
  issueTransitionType,
} from '../../../../../constants/proptype-validation';
import FilterSearchIcon from '../../../../FilterSearchIcon';
import {
  statusColorMapping,
  STATUS_CLOSED,
  STATUS_VOID,
} from '../../../../../constants/status-types';
import { viewTypes } from '../../../../../constants/view-types';
import {
  ISSUE_ATTRIBUTE_NAMES,
  ISSUE_BE_ATTRIBUTE_NAMES,
} from '../../../../../constants/issue-attribute-names';
import { presenceValidator, isDatePastValidator } from '../../../../../utils/validation-helpers';
import { getUsersList } from '../../../../../utils/assigned-to-helpers';
import { getUserCompanyName } from '../../../../../utils/userHelpers';
import {
  createTransitionStatusOption,
  getTransitionSaveButtonTextKey,
  getStatusFromServerStatus,
} from '../../../../../utils/transition-helpers';
import {
  FE_TRANSITION_FIELDS,
  ASSIGN_TO_TRANSLATION_KEYS,
} from '../../../../../constants/transitions';
import RfiCustomIdentifier from '../../../../RfiCustomIdentifier';
import {
  getPermittedStatuses,
  getTransitionAssignees,
  isAttributePermitted,
} from '../../../../../utils/issues-helpers';

export class PureIssuePreviewTransitionPopUpForm extends PureComponent {
  constructor(props) {
    super(props);

    this.state = this.getInitialState();

    this.contentDiv = React.createRef();
    this.onIssueSaveFinish = this.onIssueSaveFinish.bind(this);
    this.onTransitionFinished = this.onTransitionFinished.bind(this);
    this.changeRfiCustomIdentifierFormValue = this.changeRfiCustomIdentifierFormValue.bind(this);
    this.changeRfiCustomIdentifierFormValidationValue = this.changeRfiCustomIdentifierFormValidationValue.bind(
      this
    );
    this.isRfiCustomIdentifierVisible = this.isRfiCustomIdentifierVisible.bind(this);
    this.getAvailableTransitionsV1 = this.getAvailableTransitionsV1.bind(this);
    this.onClose = this.onClose.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.scrollToActiveElement = this.scrollToActiveElement.bind(this);
    this.isRevision = !!(props.transitionFields.find(
      (item) => item.fieldName === FE_TRANSITION_FIELDS.CREATE_REVISION
    ));
  }

  getInitialState() {
    return {
      isSavingIssue: false,
      isSendingComment: false,
      rawCommentText: null,
    };
  }

  componentWillMount() {
    const {
      changeToStatus,
      issue,
      changeFormValueAction,
      setErrorsFormAction,
      transitionFields,
      transitionForm,
      document,
      viewType,
    } = this.props;

    const transitionFormAttributeNames = Object.values(ISSUE_ATTRIBUTE_NAMES);

    // the filter is making sure that we wont pass any attributes that are not in ISSUE_ATTRIBUTE_NAMES list
    transitionFields
      .filter((transitionField) => transitionFormAttributeNames.includes(transitionField.fieldName))
      .forEach((f) => {
        const newValues = {};
        this.populateFormIfNeeded(f, newValues);
        const value = lodashGet(transitionForm, `${f.fieldName}.value`) || newValues[f.fieldName];

        if (f.isMandatory) {
          setErrorsFormAction(`transitionForm.${f.fieldName}`, !presenceValidator(value));
        }

        if (f.fieldName === ISSUE_ATTRIBUTE_NAMES.DUE_DATE) {
          setErrorsFormAction(
            `transitionForm.${f.fieldName}`,
            !isDatePastValidator(value, f.isMandatory)
          );
        }
      });

    this.updateStatusOrTransition(this.props);
    const shouldUpdateCloseVersion = () => {
      const isPermitted = isAttributePermitted(
        issue,
        ISSUE_BE_ATTRIBUTE_NAMES[ISSUE_ATTRIBUTE_NAMES.CLOSE_VERSION]
      );
      return isPermitted && changeToStatus === STATUS_CLOSED && viewType === viewTypes.DOCUMENT;
    };
    if (shouldUpdateCloseVersion()) {
      const documentVersion = document ? document.version : issue.startingVersion; // Fallback for when the document does not exist
      if (documentVersion !== undefined) {
        changeFormValueAction(
          `transitionForm.${ISSUE_ATTRIBUTE_NAMES.CLOSE_VERSION}`,
          documentVersion
        );
      }
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const isStatusChanged = this.props.pendingTransition !== nextProps.pendingTransition;
    if (isStatusChanged) {
      this.updateStatusOrTransition(nextProps);
    }
  }

  componentWillUnmount() {
    this.props.resetFormAction('transitionForm');
    this.props.resetValidityFormAction('transitionForm');
  }

  updateStatusOrTransition(props) {
    const { pendingTransition, changeFormValueAction, setErrorsFormAction } = props;
    const transitionId = pendingTransition.value;
    changeFormValueAction(`transitionForm.${ISSUE_ATTRIBUTE_NAMES.TRANSITION_ID}`, transitionId);
    setErrorsFormAction(
      `transitionForm.${ISSUE_ATTRIBUTE_NAMES.TRANSITION_ID}`,
      !presenceValidator(transitionId)
    );
  }

  populateFormIfNeeded(field, newValues) {
    const { issue, changeFormValueAction } = this.props;
    switch (field.fieldName) {
      case ISSUE_ATTRIBUTE_NAMES.ASSIGNED_TO: {
        const assignedToOptions = this.getAssignedToOptions();
        if (assignedToOptions.length === 1) {
          newValues[ISSUE_ATTRIBUTE_NAMES.ASSIGNED_TO] = assignedToOptions[0].oxygenId;
          changeFormValueAction(
            `transitionForm.${ISSUE_ATTRIBUTE_NAMES.ASSIGNED_TO}`,
            assignedToOptions[0].oxygenId
          );
        }
        break;
      }
      case ISSUE_ATTRIBUTE_NAMES.DUE_DATE: {
        newValues[ISSUE_ATTRIBUTE_NAMES.DUE_DATE] = issue.dueDate ? issue.dueDate : null;
        changeFormValueAction(
          `transitionForm.${ISSUE_ATTRIBUTE_NAMES.DUE_DATE}`,
          issue.dueDate ? issue.dueDate : null
        );
        break;
      }
      case ISSUE_ATTRIBUTE_NAMES.CO_REVIEWERS: {
        newValues[ISSUE_ATTRIBUTE_NAMES.CO_REVIEWERS] = issue[ISSUE_ATTRIBUTE_NAMES.CO_REVIEWERS];
        changeFormValueAction(
          `transitionForm.${ISSUE_ATTRIBUTE_NAMES.CO_REVIEWERS}`,
          issue[ISSUE_ATTRIBUTE_NAMES.CO_REVIEWERS]
        );
        break;
      }
      case ISSUE_ATTRIBUTE_NAMES.DISTRIBUTION_LIST: {
        newValues[ISSUE_ATTRIBUTE_NAMES.DISTRIBUTION_LIST] =
          issue[ISSUE_ATTRIBUTE_NAMES.DISTRIBUTION_LIST];
        changeFormValueAction(
          `transitionForm.${ISSUE_ATTRIBUTE_NAMES.DISTRIBUTION_LIST}`,
          issue[ISSUE_ATTRIBUTE_NAMES.DISTRIBUTION_LIST]
        );
        break;
      }
      case ISSUE_ATTRIBUTE_NAMES.CUSTOM_IDENTIFIER: {
        newValues[ISSUE_ATTRIBUTE_NAMES.CUSTOM_IDENTIFIER] =
          issue[ISSUE_ATTRIBUTE_NAMES.CUSTOM_IDENTIFIER];
        changeFormValueAction(
          `transitionForm.${ISSUE_ATTRIBUTE_NAMES.CUSTOM_IDENTIFIER}`,
          issue[ISSUE_ATTRIBUTE_NAMES.CUSTOM_IDENTIFIER]
        );
        break;
      }
      case ISSUE_ATTRIBUTE_NAMES.ANSWER: {
        newValues[ISSUE_ATTRIBUTE_NAMES.ANSWER] = issue[ISSUE_ATTRIBUTE_NAMES.ANSWER];
        changeFormValueAction(
          `transitionForm.${ISSUE_ATTRIBUTE_NAMES.ANSWER}`,
          issue[ISSUE_ATTRIBUTE_NAMES.ANSWER]
        );
        break;
      }
      default:
        changeFormValueAction(`transitionForm.${field.fieldName}`, null);
    }
  }

  onClose() {
    this.setState(this.getInitialState());
    this.props.closePopup();
  }

  onTransitionFinished() {
    const { closeIssuePreview } = this.props;
    this.onClose();
    if (!this.isRevision) {
      closeIssuePreview();
    }
  }

  handleSave() {
    const { issue, changeToStatus, updateIssueAction, showCreateRevisionField } = this.props;
    const attributes = this.generateIssueAttributes();
    // For reopen with revision, skip custom id field if null/empty
    if ( issue.status === STATUS_CLOSED && !attributes.customIdentifier) {
      delete attributes.customIdentifier;
    }
    if (!isEmpty(attributes)) {
      this.setState({ isSavingIssue: true });
      const rfiCustomIdentifierAnalyticsData = this.isRfiCustomIdentifierVisible()
        ? this.props.rfiCustomIdentifierAnalyticsData
        : null;
      if (changeToStatus === STATUS_CLOSED) {
        // update distributionList and then close RFI (https://jira.autodesk.com/browse/SCPJM-3064)
        // eslint-disable-next-line no-unused-vars
        const { distributionList, assignedTo: _assignedTo, ...restAttributes } = attributes;
        const closeRfi = () =>
          updateIssueAction(issue, restAttributes, {
            onError: this.onIssueSaveFinish,
            onSuccess: this.onIssueSaveFinish,
            changeToStatus,
            rfiCustomIdentifierAnalyticsData,
          });
        updateIssueAction(
          issue,
          { distributionList },
          { onError: this.onIssueSaveFinish, onSuccess: closeRfi, rfiCustomIdentifierAnalyticsData }
        );
      } else {
        updateIssueAction(issue, attributes, {
          onError: this.onIssueSaveFinish,
          onSuccess: this.onIssueSaveFinish,
          changeToStatus,
          rfiCustomIdentifierAnalyticsData,
          showCreateRevisionField,
        });
      }
    }
  }

  createComment(commentText) {
    const { issue, createCommentAction } = this.props;
    const issueId = issue.id;
    this.setState({ isSendingComment: true });
    return new Promise((resolve, reject) => {
      createCommentAction(issueId, commentText, resolve, reject);
    })
      .then(() => this.onCommentSaveFinish())
      .catch(() => this.onCommentSaveFinish());
  }

  generateIssueAttributes() {
    const { transitionForm, showCreateRevisionField, issue } = this.props;
    const attributes = {};
    const removeEmptyValues = [ISSUE_ATTRIBUTE_NAMES.COMMENTS_ATTRIBUTES];
    const multiSelectValues = [
      ISSUE_ATTRIBUTE_NAMES.DISTRIBUTION_LIST,
      ISSUE_ATTRIBUTE_NAMES.CO_REVIEWERS,
    ];

    const getServerFieldName = (fieldName) => {
      if (fieldName === ISSUE_ATTRIBUTE_NAMES.TRANSITION_ID) {
        return ISSUE_ATTRIBUTE_NAMES.STATUS;
      }
      return fieldName;
    };

    Object.keys(transitionForm).forEach((fieldName) => {
      const value = multiSelectValues.includes(fieldName)
        ? lodashGet(transitionForm, `${fieldName}.$form.value`, [])
        : transitionForm[fieldName].value;
      const isClosedStatus = issue.status === STATUS_CLOSED;
      const isCustomIdField = fieldName === ISSUE_ATTRIBUTE_NAMES.CUSTOM_IDENTIFIER;
      const shouldRemoveCustomIdField =
        isClosedStatus && isCustomIdField && !showCreateRevisionField;

      if (!removeEmptyValues.includes(fieldName) || value) {
        // We want to ignore empty values of "COMMENTS_ATTRIBUTES".
        if (fieldName === ISSUE_ATTRIBUTE_NAMES.COMMENTS_ATTRIBUTES) {
          // Special handling for comment structure expected by BE
          attributes[fieldName] = [{ body: value }];
        } else if (shouldRemoveCustomIdField) {
          // Skip custom identifer field for reopen RFI if rfi is reopened without revision
          delete attributes[fieldName];
        } else {
          attributes[getServerFieldName(fieldName)] = value;
        }
      }
    });

    return attributes;
  }

  onIssueSaveFinish() {
    this.setState({ isSavingIssue: false });

    if (!this.state.isSendingComment) {
      this.onTransitionFinished();
    }
  }

  onCommentSaveFinish() {
    this.setState({ isSendingComment: false });
    if (!this.state.isSavingIssue) {
      this.onTransitionFinished();
    }
  }

  renderLabel(label, isMandatory) {
    const classes = cx('IssuePreviewTransitionPopUpForm__field-label', {
      'IssuePreviewTransitionPopUpForm__field-label--required': isMandatory,
    });
    return <Label className={classes}>{label}</Label>;
  }

  handleFieldChange(value, fieldName, isMandatory) {
    const { changeFormValueAction, setErrorsFormAction } = this.props;

    changeFormValueAction(`transitionForm.${fieldName}`, value);
    if (isMandatory) {
      setErrorsFormAction(`transitionForm.${fieldName}`, !presenceValidator(value));
    }
    if (fieldName === ISSUE_ATTRIBUTE_NAMES.DUE_DATE) {
      setErrorsFormAction(`transitionForm.${fieldName}`, !isDatePastValidator(value, isMandatory));
    }
  }

  changeRfiCustomIdentifierFormValue(value) {
    const { changeFormValueAction } = this.props;
    changeFormValueAction(`transitionForm.${ISSUE_ATTRIBUTE_NAMES.CUSTOM_IDENTIFIER}`, value);
  }

  changeRfiCustomIdentifierFormValidationValue(isValid) {
    const { setErrorsFormAction } = this.props;
    setErrorsFormAction(`transitionForm.${ISSUE_ATTRIBUTE_NAMES.CUSTOM_IDENTIFIER}`, !isValid);
  }

  getAvailableTransitionsV1(transitionIds) {
    const { issue } = this.props;
    const options = [];
    transitionIds.map((transitionId) => {
      const transition = lodashGet(issue, 'permittedTransitions', []).find(
        (t) => t.id === transitionId
      );
      if (transition) {
        options.push(createTransitionStatusOption(transition));
      }
    });
    return options;
  }

  getAvailableTransitions(transitions) {
    const { issue } = this.props;
    const options = [];
    transitions.map(({ status }) => {
      const transition = lodashGet(issue, 'permittedActions.updateRfi.permittedStatuses', []).find(
        (t) => t.status === status
      );
      if (transition) {
        options.push(createTransitionStatusOption(transition));
      }
    });
    return options;
  }

  renderRfiCustomIdentifier(field) {
    const { transitionForm, issue } = this.props;
    const customIdentifierField = transitionForm[ISSUE_ATTRIBUTE_NAMES.CUSTOM_IDENTIFIER];
    const isCustomIdentifierLoaded = !!customIdentifierField;
    if (!isCustomIdentifierLoaded) {
      return null;
    }
    const { value } = customIdentifierField;
    const populateRfiCustomIdentifier = this.isRevision || !value;
    const serverValue = issue[ISSUE_ATTRIBUTE_NAMES.CUSTOM_IDENTIFIER];
    return (
      <div key={field.fieldName} className="IssuePreviewTransitionPopUpForm__field">
        <RfiCustomIdentifier
          value={value}
          serverValue={serverValue}
          onChange={this.changeRfiCustomIdentifierFormValue}
          onValidationChange={this.changeRfiCustomIdentifierFormValidationValue}
          className="IssuePreviewTransitionPopUpForm__field IssuePreviewTransitionPopUpForm__custom-identifier-field"
          populateRfiCustomIdentifierOnMount={populateRfiCustomIdentifier}
          isRevision={this.isRevision}
          container={this}
          rfiId={issue.id}
          disabled={field.disabled}
          readOnly={field.readOnly}
        />
      </div>
    );
  }

  renderStatusDropdown(field) {
    const { changeToStatus, onStatusChange } = this.props;

    const textLabelStatus = T.translate('new.status');

    const options = this.getAvailableTransitions(field.values);

    return (
      <div
        className="IssuePreviewTransitionPopUpForm__field"
        data-testid="IssuePreviewTransitionPopUpForm__status-field"
        key={ISSUE_ATTRIBUTE_NAMES.STATUS}
      >
        {this.renderLabel(textLabelStatus, field.isMandatory)}
        <SelectDropdown
          selectedOptions={options.find((option) => option.value === changeToStatus)}
          options={options}
          optionRenderer={(value, label) => (
            <StatusColorIndicatorOption
              statusColor={statusColorMapping[getStatusFromServerStatus(value)]}
              label={label}
            />
          )}
          valueRenderer={(value, label) => (
            <StatusColorIndicatorOption
              statusColor={statusColorMapping[getStatusFromServerStatus(value)]}
              label={label}
            />
          )}
          onChange={onStatusChange}
        />
      </div>
    );
  }

  getAssignedToOptions() {
    const { pendingTransition, issue, oxygen } = this.props;

    const transition = getPermittedStatuses(issue).find(
      (permittedTransition) => permittedTransition.serverStatus === pendingTransition.value
    );
    const transitionUsers = getTransitionAssignees(transition).length
      ? getTransitionAssignees(transition)
      : issue.assignees;
    const assignedToUsersList = getUsersList(transitionUsers, oxygen);
    return assignedToUsersList.length === 0 && oxygen.users[issue.assignedTo]
      ? [oxygen.users[issue.assignedTo]]
      : assignedToUsersList;
  }

  getAssignToLabel() {
    const { pendingTransition } = this.props;
    const key = pendingTransition.value;
    const translationKey = ASSIGN_TO_TRANSLATION_KEYS[key];
    if (translationKey) {
      return T.translate(translationKey);
    }

    return T.translate('transition.assignTo.label');
  }

  renderAssignedToDropdown(field) {
    const { transitionForm } = this.props;
    const { isMandatory } = field;
    const selectedUserOxygenId = lodashGet(
      transitionForm,
      `${ISSUE_ATTRIBUTE_NAMES.ASSIGNED_TO}.value`
    );

    const textLabelAssignedTo = this.getAssignToLabel();

    const textPlaceholderAssignedTo = T.translate('new.placeholder.assignedToUsers');

    const assignedToOptions = this.getAssignedToOptions();

    if (assignedToOptions.length === 1) {
      // When only one available assignee - no need for dropdown.
      return (
        <div
          className="IssuePreviewTransitionPopUpForm__field"
          data-testid="IssuePreviewTransitionPopUpForm__assignedTo-field"
          key={ISSUE_ATTRIBUTE_NAMES.ASSIGNED_TO}
        >
          <Label>{textLabelAssignedTo}</Label>
          <TextFieldCore
            behavior={TextFieldCore.Behaviors.SINGLE_LINE}
            value={assignedToOptions[0].name}
            disabled
          />
        </div>
      );
    }
    return (
      <div
        className="IssuePreviewTransitionPopUpForm__field"
        data-testid="IssuePreviewTransitionPopUpForm__assignedTo-field"
        key={ISSUE_ATTRIBUTE_NAMES.ASSIGNED_TO}
      >
        {this.renderLabel(textLabelAssignedTo, isMandatory)}
        <SelectDropdown
          options={assignedToOptions}
          selectedOptions={selectedUserOxygenId ? { oxygenId: selectedUserOxygenId } : null}
          clearable={!isMandatory}
          labelKey="name"
          valueKey="oxygenId"
          subtextGetter={getUserCompanyName}
          placeholder={textPlaceholderAssignedTo}
          searchable
          searchIcon={<FilterSearchIcon />}
          searchPlaceholder={T.translate('filter.assignedToSearch')}
          onChange={(value) => {
            this.handleFieldChange(
              value ? value.oxygenId : null,
              ISSUE_ATTRIBUTE_NAMES.ASSIGNED_TO,
              isMandatory
            );
          }}
        />
      </div>
    );
  }

  renderCoReviewersDropdown(field) {
    const { isMandatory } = field;
    const textLabelCoReviewers = T.translate('new.coReviewers');
    const textPlaceholderCoReviewers = T.translate('new.placeholder.coReviewers');

    return this.renderMultiUserSelectDropdown(
      isMandatory,
      ISSUE_ATTRIBUTE_NAMES.CO_REVIEWERS,
      textLabelCoReviewers,
      textPlaceholderCoReviewers
    );
  }

  renderDistributionListDropdown(field) {
    const { isMandatory } = field;
    const textLabelDistributionList = T.translate('new.distributionList');
    const textPlaceholderDistributionList = T.translate('new.placeholder.distributionList');

    return this.renderMultiUserSelectDropdown(
      isMandatory,
      ISSUE_ATTRIBUTE_NAMES.DISTRIBUTION_LIST,
      textLabelDistributionList,
      textPlaceholderDistributionList
    );
  }

  renderMultiUserSelectDropdown(isMandatory, fieldName, label, placeholder) {
    const { users, transitionForm } = this.props;
    const selectedUserOxygenIds = lodashGet(transitionForm, `${fieldName}.$form.value`, []);

    return (
      <div className="IssuePreviewTransitionPopUpForm__field" key={fieldName}>
        {this.renderLabel(label, isMandatory)}
        <SelectDropdown
          options={users}
          selectedOptions={users.filter((u) => selectedUserOxygenIds.includes(u.oxygenId))}
          clearable={!isMandatory}
          multi
          labelKey="name"
          valueKey="oxygenId"
          subtextGetter={getUserCompanyName}
          placeholder={placeholder}
          searchable
          searchIcon={<FilterSearchIcon />}
          onChange={(value) => {
            this.handleFieldChange(
              value.map((u) => u.oxygenId),
              fieldName,
              isMandatory
            );
          }}
        />
      </div>
    );
  }

  renderComment(field) {
    const { groupedProjectEntitiesForMention } = this.props;
    const { isMandatory } = field;
    const textLabelComment = T.translate('comment.label');

    return (
      <div
        className="IssuePreviewTransitionPopUpForm__field"
        data-testid="IssuePreviewTransitionPopUpForm__comment-field"
        key={ISSUE_ATTRIBUTE_NAMES.COMMENTS_ATTRIBUTES}
      >
        {this.renderLabel(textLabelComment, isMandatory)}
        <MentionInput
          className="IssuePreviewTransitionPopUpForm__mention-input"
          data-testid="IssuePreviewTransitionPopUpForm__mention-input"
          suggestions={groupedProjectEntitiesForMention}
          onChange={(value) => {
            const rawCommentText = value ? value.trim() : null;
            this.setState({ rawCommentText });
            this.handleFieldChange(
              value ? rawCommentText : null,
              ISSUE_ATTRIBUTE_NAMES.COMMENTS_ATTRIBUTES,
              isMandatory
            );
          }}
          getSuggestionId={(user) => user.oxygenId}
          getSuggestionName={(user) => user.name}
          getMentionId={(user) => user.oxygenId}
          getMentionName={(user) => user.name}
          getMentionType={(user) => user.oxygenType}
        />
      </div>
    );
  }

  renderRfiCreateRevisionCheckbox(field) {
    const { onToggleCreateRevision } = this.props;
    return (
      <div
        className="IssuePreviewTransitionPopUpForm__field"
        data-testid="IssuePreviewTransitionPopUpForm__comment-field"
        key={FE_TRANSITION_FIELDS.CREATE_REVISION}
      >
        <Checkbox onChange={onToggleCreateRevision} label={T.translate('new.revision')} />
      </div>
    );
  }

  renderAnswer(field) {
    const { isMandatory } = field;
    const textLabelAnswer = T.translate('answer.officialResponse');
    const placeholder = T.translate('answer.officialResponsePlaceholder');
    return (
      <div className="IssuePreviewTransitionPopUpForm__field" key={ISSUE_ATTRIBUTE_NAMES.ANSWER}>
        {this.renderLabel(textLabelAnswer, isMandatory)}
        <TextFieldCore
          behavior={TextFieldCore.Behaviors.MULTI_LINE}
          value={lodashGet(this.props.transitionForm, `${ISSUE_ATTRIBUTE_NAMES.ANSWER}.value`)}
          placeholder={placeholder}
          onChange={(value) =>
            this.handleFieldChange(value, ISSUE_ATTRIBUTE_NAMES.ANSWER, isMandatory)
          }
          className="IssuePreviewTransitionPopUpForm__answer"
          data-testid="IssuePreviewTransitionPopUpForm__answer"
        />
      </div>
    );
  }

  scrollToActiveElement() {
    if (this.contentDiv.current) {
      this.contentDiv.current.scrollTop = this.contentDiv.current.parentNode.scrollHeight;
    }
  }

  renderDueDate(field) {
    const { transitionForm } = this.props;
    const { isMandatory } = field;
    const textLabelDueDate = T.translate('new.dueDate');
    const textPlaceholderDueDate = T.translate('new.placeholder.dueDate');
    const selectedDate = lodashGet(transitionForm, `${ISSUE_ATTRIBUTE_NAMES.DUE_DATE}.value`);
    const valid = isDatePastValidator(selectedDate, isMandatory);
    return (
      <div
        className="IssuePreviewTransitionPopUpForm__field"
        data-testid="IssuePreviewTransitionPopUpForm__dueDate-field"
        key={ISSUE_ATTRIBUTE_NAMES.DUE_DATE}
      >
        {this.renderLabel(textLabelDueDate, isMandatory)}
        <DatePicker
          disablePastDates
          hideClearDateButton={isMandatory}
          date={selectedDate}
          valid={valid}
          onChange={(value) => {
            this.handleFieldChange(value, ISSUE_ATTRIBUTE_NAMES.DUE_DATE, isMandatory);
          }}
          placeholder={textPlaceholderDueDate}
          onOpen={this.scrollToActiveElement}
        />
        {!valid ? (
          <div className="IssuePreviewTransitionPopUpForm__field-error">
            {T.translate('validationMessages.dueDatePast')}
          </div>
        ) : null}
      </div>
    );
  }

  renderTitle() {
    if (this.props.changeToStatus === STATUS_VOID) {
      const title = T.translate(`transition.title.${this.props.changeToStatus}`);
      const message = T.translate(`transition.message.${this.props.changeToStatus}`);

      return (
        <div className="IssuePreviewTransitionPopUpForm__title IssuePreviewTransitionPopUpForm__field">
          <div
            className="IssuePreviewTransitionPopUpForm__title-text"
            data-testid="IssuePreviewTransitionPopUpForm__title-text"
          >
            {title}
          </div>
          <div className="IssuePreviewTransitionPopUpForm__message">{message}</div>
        </div>
      );
    }
    return null;
  }

  renderInfo(field) {
    return (
      <div
        className="IssuePreviewTransitionPopUpForm__field IssuePreviewTransitionPopUpForm__info"
        key={FE_TRANSITION_FIELDS.INFO}
      >
        <SvgIcon
          width="14px"
          height="14px"
          className="IssuePreviewTransitionPopUpForm__info-icon"
          svgId="info-circle"
        />
        <div className="IssuePreviewTransitionPopUpForm__info-text">
          {T.translate(field.translationKey)}
        </div>
      </div>
    );
  }

  // eslint-disable-next-line consistent-return
  renderField(field) {
    // eslint-disable-next-line default-case
    switch (field.fieldName) {
      case FE_TRANSITION_FIELDS.CREATE_REVISION:
        return this.renderRfiCreateRevisionCheckbox(field);
      case ISSUE_ATTRIBUTE_NAMES.TRANSITION_ID:
      case ISSUE_ATTRIBUTE_NAMES.STATUS:
        return this.renderStatusDropdown(field);
      case ISSUE_ATTRIBUTE_NAMES.ASSIGNED_TO:
        return this.renderAssignedToDropdown(field);
      case ISSUE_ATTRIBUTE_NAMES.CO_REVIEWERS:
        return this.renderCoReviewersDropdown(field);
      case ISSUE_ATTRIBUTE_NAMES.DISTRIBUTION_LIST:
        return this.renderDistributionListDropdown(field);
      case ISSUE_ATTRIBUTE_NAMES.COMMENTS_ATTRIBUTES:
        return this.renderComment(field);
      case ISSUE_ATTRIBUTE_NAMES.DUE_DATE:
        return this.renderDueDate(field);
      case ISSUE_ATTRIBUTE_NAMES.ANSWER:
        return this.renderAnswer(field);
      case ISSUE_ATTRIBUTE_NAMES.CUSTOM_IDENTIFIER:
        return this.renderRfiCustomIdentifier(field);
      case FE_TRANSITION_FIELDS.INFO:
        return this.renderInfo(field);
    }
  }

  getSaveButtonText(isSaving) {
    const { pendingTransition, issue } = this.props;
    let textKey;

    if (isSaving) {
      textKey = 'transition.saving';
    } else {
      textKey = getTransitionSaveButtonTextKey(pendingTransition, issue.status);
    }

    if (!textKey) {
      textKey = 'navigation.done';
    }

    return T.translate(textKey);
  }

  isRfiCustomIdentifierVisible() {
    return this.props.transitionFields.find(
      (field) => field.fieldName === ISSUE_ATTRIBUTE_NAMES.CUSTOM_IDENTIFIER
    );
  }

  render() {
    const { viewType, transitionFields, transitionFormState, showCreateRevisionField } = this.props;
    const { isSavingIssue, isSendingComment } = this.state;
    const isSaving = isSendingComment || isSavingIssue;

    const isDisabled = isSaving || !transitionFormState.valid;
    const isFormValid = this.isRevision ? showCreateRevisionField && isDisabled : isDisabled;

    const divClassNames = cx('IssuePreviewTransitionPopUpForm', {
      IssuePreviewTransitionPopUpForm__narrow: viewType === viewTypes.DOCUMENT,
      IssuePreviewTransitionPopUpForm__wide: viewType === viewTypes.PROJECT,
    });

    const cancelButtonText = T.translate('navigation.cancel');
    const saveButtonText = this.getSaveButtonText(isSaving);

    const saveButtonClasses = cx('IssuePreviewTransitionPopUpForm__save-button', {
      'IssuePreviewTransitionPopUpForm__save-button--saving': isSaving,
    });
    return (
      <div className={divClassNames}>
        <div className="IssuePreviewTransitionPopUpForm__content" ref={this.contentDiv}>
          {this.renderTitle()}
          {transitionFields.map((field) => this.renderField(field))}
        </div>
        <div className="IssuePreviewTransitionPopUpForm__footer">
          <Button
            styleType={Button.StyleType.LINK_SECONDARY}
            data-testid="IssuePreviewTransitionPopUpForm__cancel-button"
            onClick={this.onClose}
            disabled={isSaving}
          >
            {cancelButtonText}
          </Button>
          <Button
            styleType={Button.StyleType.PRIMARY}
            className={saveButtonClasses}
            data-testid="IssuePreviewTransitionPopUpForm__saveButton"
            onClick={this.handleSave}
            disabled={isFormValid}
          >
            {saveButtonText}
          </Button>
        </div>
      </div>
    );
  }
}

PureIssuePreviewTransitionPopUpForm.displayName = 'IssuePreviewTransitionPopUpForm';

PureIssuePreviewTransitionPopUpForm.propTypes = {
  issue: issueAttributesType,
  document: documentType,
  changeToStatus: PropTypes.string,
  pendingTransition: issueTransitionType,
  transitionFields: PropTypes.array,
  issueStatusOptions: statusOptionsArrayType.isRequired,
  oxygen: oxygenType.isRequired,
  groupedProjectEntities: PropTypes.array.isRequired,
  groupedProjectEntitiesForMention: PropTypes.array.isRequired,
  users: PropTypes.array.isRequired,
  closePopup: PropTypes.func.isRequired,
  onStatusChange: PropTypes.func.isRequired,
  onToggleCreateRevision: PropTypes.func.isRequired,
  transitionForm: PropTypes.object.isRequired,
  transitionFormState: PropTypes.object.isRequired,
  updateIssueAction: PropTypes.func.isRequired,
  changeFormValueAction: PropTypes.func.isRequired,
  resetFormAction: PropTypes.func.isRequired,
  resetValidityFormAction: PropTypes.func.isRequired,
  setErrorsFormAction: PropTypes.func.isRequired,
  createCommentAction: PropTypes.func.isRequired,
  currentUser: userType,
  viewType: PropTypes.string.isRequired,
  trackEvent: PropTypes.func,
  closeIssuePreview: PropTypes.func.isRequired,
  rfiCustomIdentifierAnalyticsData: PropTypes.object.isRequired,
  showCreateRevisionField: PropTypes.bool.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  transitionForm: getTransitionFormAttributes(state),
  transitionFormState: getTransitionFormState(state),
  document: getDocumentCollection(state)[ownProps.issue.targetUrn],
  currentUser: getCurrentUser(state),
  issueStatusOptions: getCurrentIssuePreviewStatusOptions(state),
  groupedProjectEntities: getGroupedProjectActiveEntities(state),
  groupedProjectEntitiesForMention: getGroupedProjectActiveEntitiesForMentionComponent(state),
  users: getActiveUsers(state),
  oxygen: getOxygenMappings(state),
  viewType: getCurrentViewType(state),
  rfiCustomIdentifierAnalyticsData: rfiCustomIdentifierAnalyticsData(state),
});

const mapDispatchToProps = {
  updateIssueAction,
  createCommentAction,
  changeFormValueAction: formActions.change,
  resetFormAction: formActions.reset,
  resetValidityFormAction: formActions.resetValidity,
  setErrorsFormAction: formActions.setErrors,
};

export default connect(mapStateToProps, mapDispatchToProps)(PureIssuePreviewTransitionPopUpForm);
